// All scheduling times are shown and entered in the business timezone (America/Edmonton),
// regardless of the browser's own timezone. Shifts are stored as UTC instants on the backend;
// these helpers convert between those instants and Edmonton wall-clock time.
export const TZ = 'America/Edmonton';

const pad = (n) => String(n).padStart(2, '0');
const WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

function offsetMs(date) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const m = {};
  for (const p of dtf.formatToParts(date)) m[p.type] = p.value;
  return Date.UTC(+m.year, +m.month - 1, +m.day, +m.hour, +m.minute, +m.second) - date.getTime();
}

export function edParts(d) {
  const date = new Date(d);
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, hourCycle: 'h23', weekday: 'short',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
  const m = {};
  for (const p of dtf.formatToParts(date)) m[p.type] = p.value;
  return { year: +m.year, month: +m.month, day: +m.day, hour: +m.hour, minute: +m.minute, weekday: WD[m.weekday] };
}

// UTC Date for a given Edmonton wall-clock time. hour/minute may overflow (Date.UTC normalizes).
export function edmontonToUtc(year, month, day, hour = 0, minute = 0) {
  const guess = Date.UTC(year, month - 1, day, hour, minute, 0);
  return new Date(guess - offsetMs(new Date(guess)));
}

export const edDayKey = (d) => { const p = edParts(d); return `${p.year}-${p.month}-${p.day}`; };
export const edDayOfWeek = (d) => edParts(d).weekday;
export const edDayStart = (d) => { const p = edParts(d); return edmontonToUtc(p.year, p.month, p.day, 0, 0); };
export const edAddDays = (d, n) => { const p = edParts(d); return edmontonToUtc(p.year, p.month, p.day + n, 0, 0); };

// "YYYY-MM-DD" + "HH:MM" (interpreted as Edmonton time) -> UTC Date instant.
export function isoFromEdmonton(dateStr, timeStr) {
  const [y, mo, da] = String(dateStr).slice(0, 10).split('-').map(Number);
  const [h, mi] = String(timeStr).split(':').map(Number);
  return edmontonToUtc(y, mo, da, h, mi || 0);
}

export function fmtEdTime(d, fmt = '12h') {
  const p = edParts(d);
  if (fmt === '24h') return `${pad(p.hour)}:${pad(p.minute)}`;
  const h = p.hour % 12 || 12;
  return `${h}:${pad(p.minute)} ${p.hour >= 12 ? 'PM' : 'AM'}`;
}

export const fmtEdDate = (d, opts) => new Date(d).toLocaleDateString('en-CA', { timeZone: TZ, ...opts });
export const edTimeInput = (d) => { const p = edParts(d); return `${pad(p.hour)}:${pad(p.minute)}`; };
export const edDateInput = (d) => { const p = edParts(d); return `${p.year}-${pad(p.month)}-${pad(p.day)}`; };
